import RestModule from "../vue-ocom/store/RestModule";
import schema from "./schema/index";
import CreateUserModule from "../vue-ocom/store/CreateUserModule";
import { CreateFileSystemModule } from "../vue-ocom/filesystem/store";

var root_url = process.env.VUE_APP_ROOT_API;

const UserModule = CreateUserModule(root_url);

const LanguageModule = RestModule(
  root_url + "/ocom_project/language/",
  schema.Language
);
const FrameworkModule = RestModule(
  root_url + "/ocom_project/framework/",
  schema.Framework
);
const DatabaseModule = RestModule(
  root_url + "/ocom_project/database/",
  schema.Database
);
const CodeLoginTypeModule = RestModule(
  root_url + "/ocom_project/code_login_type/",
  schema.CodeLoginType
);
const ProjectLoginModule = RestModule(
  root_url + "/ocom_project/project_login/",
  schema.ProjectLogin
);
const OcomClientModule = RestModule(
  root_url + "/ocom_project/ocom_client/",
  schema.OcomClient
);
const OcomProjectModule = RestModule(
  root_url + "/ocom_project/ocom_project/",
  schema.OcomProject
);
const OcomQuoteOldModule = RestModule(
  root_url + "/ocom_project/ocom_quote_old/",
  schema.OcomQuoteOld
);
const QuoteLineModule = RestModule(
  root_url + "/ocom_project/quote_line/",
  schema.QuoteLine
);
const CodeFrontEndModule = RestModule(
  root_url + "/ocom_project/code_front_end/",
  schema.CodeFrontEnd
);
const CodeQuoteTypeModule = RestModule(
  root_url + "/ocom_project/code_quote_type/",
  schema.CodeQuoteType
);
const DocumentTemplateModule = RestModule(
  root_url + "/ocom_project/document_template/",
  schema.DocumentTemplate
);
const DocumentTemplateVersionModule = RestModule(
  root_url + "/ocom_project/document_template_version/",
  schema.DocumentTemplateVersion
);
const DocumentTemplateSectionModule = RestModule(
  root_url + "/ocom_project/document_template_section/",
  schema.DocumentTemplateSection
);
const OcomQuoteVersionModule = RestModule(
  root_url + "/ocom_project/ocom_quote_version/",
  schema.OcomQuoteVersion
);
const OcomQuoteModule = RestModule(
  root_url + "/ocom_project/ocom_quote/",
  schema.OcomQuote
);
const CodeTaskTypeModule = RestModule(
  root_url + "/ocom_project/code_task_type/",
  schema.CodeTaskType
);
const CodeQuoteStatusModule = RestModule(
  root_url + "/ocom_project/code_quote_status/",
  schema.CodeQuoteStatus
);
const UserRoleModule = RestModule(
  root_url + "/ocom_project/user_role/",
  schema.UserRole
);
const UserStoryModule = RestModule(
  root_url + "/ocom_project/user_story/",
  schema.UserStory
);
const TimesheetEntryModule = RestModule(
  root_url + "/ocom_project/timesheet_entry/",
  schema.TimesheetEntry
);
const CodeUserStoryStatusModule = RestModule(
  root_url + "/ocom_project/code_user_story_status/",
  schema.CodeUserStoryStatus
);
//Add more modules here if needed. These will automatically be included and available in main store.

const FileSystemModule = CreateFileSystemModule("/filesystem");

export default {
  UserModule,

  LanguageModule,
  FrameworkModule,
  DatabaseModule,
  CodeLoginTypeModule,
  ProjectLoginModule,
  OcomClientModule,
  OcomProjectModule,
  OcomQuoteOldModule,
  QuoteLineModule,
  CodeFrontEndModule,
  CodeQuoteTypeModule,
  DocumentTemplateModule,
  DocumentTemplateVersionModule,
  DocumentTemplateSectionModule,
  OcomQuoteVersionModule,
  OcomQuoteModule,
  CodeTaskTypeModule,
  CodeQuoteStatusModule,
  UserRoleModule,
  UserStoryModule,
  TimesheetEntryModule,
  CodeUserStoryStatusModule,
  //Add more modules here
  FileSystemModule,
};
